enum FeatureFlag {
  FIELDS_INSTRUCTION_HTML = "fields-instruction-html",
  MULTIPLE_PHOTOS = "multiple-photos",
  TASK_REASSIGN = "task-reassign",
}

export default FeatureFlag;
